import React from "react";
import { StyledButton } from "../../styled/ErrorButton";

const ErrorButton = ({ text, icon, action, color = "primary" }) => {
  return (
    <StyledButton
      variant="contained"
      color={color}
      type="submit"
      startIcon={icon}
      onClick={action}>
      {text}
    </StyledButton>
  );
};

export default ErrorButton;
